import React, { useRef } from "react";
import * as XLSX from "xlsx";

const GroupTable = ({ Group, title }) => {
  const tableRef = useRef(null);

  const handleExport = () => {
    if (!tableRef.current) return;

    // Convert table DOM → worksheet
    const ws = XLSX.utils.table_to_sheet(tableRef.current.querySelector("table"));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, title);

    // Save file as .xlsx
    XLSX.writeFile(wb, `${title}_table.xlsx`);
  };

  return (
    <div className="food-column-group">
      <div className="table-responsive-food-header">
        <div className="bg-heading-food">
          <h4 className="food-heading">{title}</h4>
        </div>
        {/* ✅ replaced DownloadTableExcel */}
        <button className="export" onClick={handleExport}>
          Export
        </button>
      </div>
      <div className="row food-table-group-row" ref={tableRef}>
        <table className="table-group">
          <thead>
            <tr>
              <th>Group:</th>
              <th>Total:</th>
            </tr>
          </thead>
          <tbody>
            {!Group?.error &&
              Group.map((food, index) => (
                <tr key={index}>
                  <td>{food.groupName}</td>
                  <td>{food.groupTotal}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupTable;
